<template>
  <div>
    <FormManager /> <!-- Add this line if FormManager is not globally registered -->
    <!-- Fieldsets Cards -->
    <div>
      <el-row v-for="(fieldsetRow, rowIndex) in fieldsetRows" :key="rowIndex">
        <el-col :span="6" v-for="(fieldset, colIndex) in fieldsetRow" :key="fieldset.id || 'add-card'">
          <!-- Regular Fieldset Card -->
          <el-card v-if="fieldset.id" class="box-card" style="margin:20px;">
            <div slot="header" class="clearfix">
              <span>
                <a :href="'/llm/fieldset/' + fieldset.id">
                  {{ fieldset.name }}
                </a>
              </span>
            </div>
            
            <div style="margin-bottom:20px;">
              <span v-if="fieldset.instructions">
                {{ fieldset.instructions }}
              </span>
              <span v-else class="text-muted">No description</span>
            </div>
            
            <p style="font-size:smaller">
              <strong>Model:</strong>
              <span v-if="fieldset.llm_provider_model">
                {{ fieldset.llm_provider_model.provider_model }}
              </span>
              <span v-else class="text-muted">No Model</span>
            </p>
            
            <p style="font-size:smaller">
              <strong>Fields:</strong>
              <span v-if="fieldset.llm_prompt_fields && fieldset.llm_prompt_fields.length > 0">
                <a 
                  v-for="(field, index) in fieldset.llm_prompt_fields" 
                  :key="field.id"
                  :href="'/llm/field/' + field.id"
                  style="text-decoration: none; margin-right: 5px;"
                  :title="'Edit field: ' + field.name">
                  {{ field.name }}<span v-if="index < fieldset.llm_prompt_fields.length - 1">,</span>
                </a>
              </span>
              <span v-else class="text-muted">No fields</span>
            </p>
            
            <p style="font-size:smaller;color:gray;">
              Last updated: {{ formatDate(fieldset.updated_at) }}
            </p>
          </el-card>

          <!-- Add Fieldset Card -->
          <el-card v-else class="box-card add-fieldset-card" style="margin:20px;">
            <div class="text-center py-4">
              <i class="fas fa-plus fa-3x text-muted mb-3"></i>
              <h5 class="text-muted mb-3">Add New Fieldset</h5>
              <button class="btn btn-primary" @click="showCreateModal = true">
                <i class="fas fa-plus"></i> Add Fieldset
              </button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- Create Fieldset Modal -->
    <el-dialog
      title="Create New LLM Prompt Fieldset"
      :visible.sync="showCreateModal"
      width="600px"
      @close="resetCreateForm">
      
      <FormManager
        v-if="showCreateModal"
        prettyEndPoint="/api/llm/fieldset/pretty/new"
        :initialFormValues="newFieldset"
        @save="createFieldset"
        @cancel="showCreateModal = false"
        :events="fieldsetCreateEvents"
        :edit_mode="true"
        :edit_mode_lock="true"
      />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "LlmPromptFieldsetsIndex",
  props: ['fieldsets'],
  data() {
    return {
      showCreateModal: false,
      creating: false,
      newFieldset: {
        name: '',
        extent_id: '',
        instructions: '',
        llm_provider_model_id: ''
      },
      availableExtents: [], // This will be populated by FormManager via pretty_attributes_map
      availableModels: [],  // This will be populated by FormManager via pretty_attributes_map
      fieldsetCreateEvents: [
        {
          label: "Create Fieldset",
          event: "save"
        },
        {
          label: "Cancel",
          event: "cancel"
        }
      ]
    }
  },
  computed: {
    fieldsetRows() {
      // Group fieldsets into rows of 4 for el-row/el-col layout, always include an "add" card
      const fieldsetsWithAdd = [...this.fieldsets, { id: null, isAddCard: true }];
      const rows = [];
      for (let i = 0; i < fieldsetsWithAdd.length; i += 4) {
        rows.push(fieldsetsWithAdd.slice(i, i + 4));
      }
      return rows;
    }
  },
  mounted() {
    console.log('Fieldsets:', this.fieldsets);
    // loadAvailableExtents and loadAvailableModels are no longer needed here
    // as FormManager will get them from the pretty_attributes_map via its endpoint.
  },
  methods: {
    goToFieldset(fieldsetId) {
      window.location.href = '/llm/fieldset/' + fieldsetId;
    },

    formatDate(dateString) {
      if (!dateString) return 'Unknown';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },

    resetCreateForm() {
      this.newFieldset = {
        name: '',
        extent_id: '',
        instructions: '',
        llm_provider_model_id: ''
      };
      this.creating = false;
    },

    // loadAvailableExtents and loadAvailableModels are removed as FormManager handles this.

    createFieldset(values) { // `values` comes from FormManager's @save event
      // Validation is handled by FormManager based on rules from pretty_attributes_map
      this.creating = true;
      console.log(values)

      // The 'store' method in LlmPromptFieldsetController expects extent_id in the body
      axios.post('/api/llm/fieldset/' + values.extent_id, values)
        .then(response => {
          this.$message.success('Fieldset created successfully');
          this.showCreateModal = false;
          this.resetCreateForm();
          
          // Redirect to the new fieldset
          window.location.href = '/llm/fieldset/' + response.data.id;
        })
        .catch(error => {
          console.error('Error creating fieldset:', error);
          let errorMessage = 'Error creating fieldset';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage += ': ' + error.response.data.message;
          }
          if (error.response && error.response.data && error.response.data.errors) {
            // Handle validation errors from Laravel if any slip through or are backend-specific
            for (const field in error.response.data.errors) {
              errorMessage += `\n- ${error.response.data.errors[field].join(', ')}`;
            }
          }
          this.$message.error(errorMessage);
          this.creating = false;
        });
    }
  }
}
</script>

<style scoped>
.text-muted {
  color: #6c757d;
  font-style: italic;
}
</style>
